import { Injectable, inject } from "@angular/core";
import { MatomoTracker } from "ngx-matomo-client";
import { PUSH_MATOMO_CATEGORY, PushSkipReason, pushSkipLabel, PushMatomoAction } from "./push-matomo-events";

export { PUSH_MATOMO_CATEGORY, PushMatomoAction, pushSkipLabel };
export type { PushSkipReason } from "./push-matomo-events";

/** Antal dage før soft-reminder / tilbud kan vises igen efter afvisning. */
export const PUSH_OFFER_COOLDOWN_DAYS = 14;

/**
 * Konsistent Matomo-tracking for push-events (samme mønster som login/app-launch).
 * Site-id sættes allerede pr. værk via initMatomoFromUmbraco.
 */
@Injectable({ providedIn: "root" })
export class PushTelemetryService {
    private readonly matomoTracker = inject(MatomoTracker, { optional: true });

    public track(action: string, name?: string): void {
        try {
            this.matomoTracker?.trackEvent(PUSH_MATOMO_CATEGORY, action, name);
        } catch {
            // Matomo må ikke vælte push-flowet
        }
    }

    public trackSkip(reason: PushSkipReason): void {
        this.track(PushMatomoAction.offerSkipped, pushSkipLabel(reason));
    }
}
